<template>
  <v-select
    :label="label"
    :items="items"
    :hide-details="shouldHideDetails"
    :value="data"
    @change="$emit('change', $event)"
  ></v-select>
</template>

<script>
export default {
    name: 'CleanScaleAfterInput',

    props: {
        data: {
            type: [String, Number],
            required: false
        },

        hideDetails: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            field: 'cleanScaleAfter',
            label: 'Cleanse Level (after)'
        }
    },
    computed: {
        items() {
            return this.$store.getters['examinations/getCleanScaleList']
        },
        shouldHideDetails() {
            return this.hideDetails
        }
    }
}
</script>